import { IConfiguration, Platform, Tenant } from './IConfiguration';

export default class LocalConfiguration implements IConfiguration {
    // domains of environments (hardcoded - react doesn't allow changes on runtime)
    readonly awsDevDomain = 'link-dev.modelical.io';
    readonly awsPreDomain = 'link-pre.modelical.io';
    readonly awsProductionDomain = 'link.modelical.io';

    // configuration attributes
    auth: any | undefined;
    parentUrl: string | undefined;
    adminMicroserviceUrl: string;
    proxyMicroserviceUrl: string;
    syncMicroserviceUrl: string;
    mioAdminUrl: string;
    parentDomain: string;
    cookiesSubfix: string;
    procoreUrl: string;
    aconexUrl: string;

    constructor() {
        // set up configuration attributes based on environment
        this.auth = {
            auth: {
                clientId: '93a915f6-5a3e-48e7-810a-6fa4a88a6a46', // This is the ONLY mandatory field that you need to supply.
                authority: 'https://login.microsoftonline.com/d8c21a0f-8e79-48d2-9314-075f557b317d', // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
                redirectUri: 'http://localhost:3000', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
                postLogoutRedirectUri: 'http://localhost:3000', // Indicates the page to navigate after logout.
                navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
                OIDCOptions: {
                    defaultScopes: ['93a915f6-5a3e-48e7-810a-6fa4a88a6a46/.default'],
                },
            },
            cache: {
                cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
        };

        this.parentUrl = `https://dev.modelical.io`;
        this.adminMicroserviceUrl = `https://admin.link.dev.modelical.io`;
        this.proxyMicroserviceUrl = `https://proxy.link.dev.modelical.io`;
        this.syncMicroserviceUrl = `https://sync.link.dev.modelical.io`;
        this.mioAdminUrl = `https://admin.api.dev.modelical.io`;
        /*     this.parentUrl = 'https://mio-web.gentlerock-f486492f.swedencentral.azurecontainerapps.io';
        this.adminMicroserviceUrl = `http://localhost:8010`;
        this.proxyMicroserviceUrl = `http://localhost:8020`;
        this.syncMicroserviceUrl = `http://localhost:8030`;
        this.mioAdminUrl = 'http://localhost:7010'; */
        this.parentDomain = 'localhost';
        this.cookiesSubfix = 'Local';
        this.procoreUrl = 'https://login-sandbox.procore.com';
        this.aconexUrl = 'https://constructionandengineering-ea.oraclecloud.com';
    }

    getPlatform = (): Platform => {
        return 'azure';
    };

    getAuth = (): any | undefined => {
        return this.auth;
    };

    getParentUrl = (): string | undefined => {
        return this.parentUrl;
    };

    getAdminMicroserviceUrl = (): string => {
        return this.adminMicroserviceUrl;
    };

    getProxyMicroserviceUrl = (): string => {
        return this.proxyMicroserviceUrl;
    };

    getSyncMicroserviceUrl = (): string => {
        return this.syncMicroserviceUrl;
    };

    getMioAdminUrl = (): string => {
        return this.mioAdminUrl;
    };

    getTenant = (): Tenant => {
        return 'modelical';
    };

    getParentDomain = (): string => {
        return this.parentDomain;
    };

    getCookiesSubfix = (): string => {
        return this.cookiesSubfix;
    };

    getProcoreUrl = (): string => {
        return this.procoreUrl;
    };

    getAconexUrl = (): string => {
        return this.aconexUrl;
    };
}
